import React from 'react';
import { LazyMessagesProvider } from './lazy-messages-provider';
export var MessagesProvider = function MessagesProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(LazyMessagesProvider, null, children);
};